import { useMemo } from 'react'

import { BalanceCell } from '../../../../../elements/BalanceCell'
import { PeriodValue } from '../../../../../types/inputTypes'
import { getVisibleColumns } from '../../constants/columnConfiguration'
import { useProfitAndLossFilters } from '../../contexts/profitAndLossFiltersContext'
import { ProfitAndLossTableRow } from '../../types/tableTypes'

interface ProfitAndLossCellsProps {
  periods: PeriodValue[]
  row: ProfitAndLossTableRow
}

export const BalanceCells = ({ row, periods }: ProfitAndLossCellsProps) => {
  const { appliedFilters } = useProfitAndLossFilters()
  const visibleColumns = getVisibleColumns(appliedFilters.showChange, appliedFilters.showGroupPercentage)
  const periodQuery = useMemo(() => appliedFilters.period, [appliedFilters.period])

  return (
    <>
      {periods.map((period) => {
        const balance = row.balances.find((balance) => balance.period === period.key)?.balance

        if (!balance) {
          return <></>
        }

        return (
          <>
            {visibleColumns.map((column, i) => (
              <BalanceCell
                balance={balance[column.key]}
                balanceType={column.key}
                id={row.originalId || row.id}
                isFirstCell={i === 0}
                key={`${period.key}-${column.key}`}
                periodQuery={periodQuery}
                type={row.type}
              />
            ))}
          </>
        )
      })}
    </>
  )
}
